// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import store from './store'
//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'

// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//video-player
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

import Paginate from 'vuejs-paginate'
import Kiko from 'kiko-rascalhao'

Vue.use(VueAwesomeSwiper)
Vue.use(VueVideoPlayer)
Vue.use(ElementUI)
Vue.use(Kiko)

Vue.component('paginate', Paginate)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }

    next();
})

router.afterEach((to, from, next) => {
    // window.scrollTo(0,0);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js